import { ReactComponent as EmailIcon } from './svg/email.svg'

export default EmailIcon
